import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  test: boolean = false;
  userDetails: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient) { }

  get userDetails$(): Observable<any> {
    if (this.userDetails.value) {
      return this.userDetails.asObservable();
    }

    return this.getUserData().pipe(map(value => {
      this.userDetails.next(value);
      return value;
    }));
  }

   getUserData<T>(): Observable<any> {
    return this.http.get<T>(`${environment.apiUrl}/Identity/PostLogin`);
  }

  IsSignIn() {

    const token = localStorage.getItem('accessToken');

    if(token){
      const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
      if((Math.floor((new Date).getTime() / 1000)) >= expiry)
      {
        return false;
      }

      return true;
    } else {
      return false;
    }
  }

  logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("username");
    localStorage.removeItem("roles");
    //window.location.href = (`/sign-in`);
    window.location.href = (`/home`);
  }
}
